'use client';

import './home-mobile.scss';
import { useEffect, useRef, useState } from 'react';
import Image from 'next/image';
import CustomRandomReveal from '@/lib/utils/CustomRandomReveal';
import { useSwiperSlide } from 'swiper/react';
import { SentenceScramble } from '@/lib/utils/SentenceScramble';

export default function Intro() {
  const swiperSlide = useSwiperSlide();
  const hasScrambledOnce = useRef(false); // persists across renders
  const sentenceScramblerRef = useRef<SentenceScramble | null>(null);
  const [updateState, setUpdateState] = useState(false);
  const [count, setCount] = useState(0);

  // Bean:  This is to update the state change so that the CustomRandomReveal only
  //        plays after the Sentence Scramble has done playing
  const _changeStateSentenceScrambler = () => {
    setUpdateState(true);
  }

  useEffect(() => {
    if (swiperSlide.isActive && !hasScrambledOnce.current) {
      if (!sentenceScramblerRef.current) {
        sentenceScramblerRef.current = new SentenceScramble('intro-scrambler', _changeStateSentenceScrambler);
      }
      sentenceScramblerRef.current.startSequentialScramble(0.1);
      hasScrambledOnce.current = true;
    }
  }, [swiperSlide?.isActive]);

  useEffect(() => {
    const handleScroll = (e: any) => {
      e.preventDefault();
    };

    document.body.style.overflow = 'hidden';
    window.addEventListener('scroll', handleScroll, { passive: false });

    return () => {
      document.body.style.overflow = 'auto';
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const _renderTextName = (titles: string[]) => {
    const caret = typeof document !== 'undefined'
      ? document.getElementsByClassName("typewriter-container")[0]
      : undefined;

    return (
      <>
        {updateState ?
          <>
            <span className='description-intro-mobile intro-scrambler'>highly skilled</span>
            <span style={{ whiteSpace: 'pre-wrap' }}> </span>
            <span className="typewriter-container pause">
              <CustomRandomReveal
                previous={titles[count]}
                next={titles[count === titles.length - 1 ? 0 : count + 1]}
                interval={100}
                delay={2}
                caret={caret}
                onComplete={() => {
                  if (count === titles.length - 1) {
                    setCount(0);
                  }
                  else {
                    setCount(count + 1);
                  }
                }}
              />
            </span>
          </>
          :
          <span className='description-intro-mobile intro-scrambler'>highly skilled creatives</span>
        }
      </>
    )
  };

  const _renderContent = () => {
    return (
      <div className='intro-container-mobile'>
        <p className='text-gray intro-scrambler'>{`< Intro >`}</p>
        <h1>
          <span className='description-intro-mobile intro-scrambler'>We run on experimentation and </span>
          <span className='description-intro-mobile intro-scrambler'>creativity.Invented from Advertising and </span>
          <span className='description-intro-mobile intro-scrambler'>Production spheres, The Other Lab thrives </span>
          <span className='description-intro-mobile intro-scrambler'>on materialising ideas with a team of </span>
          {_renderTextName(['creatives', 'suits', 'developers', 'programmers', 'artists', 'illustrators', 'designers'])}
        </h1>
        <p className={'text-gray-carrot'}>{'<>'}</p>
        <div className="image-group-container">
          <p className='text-start-intro intro-scrambler' aria-hidden="true">CONCOCTING</p>
          <p className='text-end-intro intro-scrambler' aria-hidden="true">CHAOS</p>
          <Image
            src='/assets/image/CIRCLES.png'
            alt=""
            width={3367}
            height={2177}
            sizes="90vw"
            className={'image__circle-home-intro'}
          />
          <div className={'image-home-intro'}>
            <img
              src="/assets/gif/FLOATINGMAN.gif"
              alt="Floating Man"
              width={1000}
              height={1000}
              style={{ width: '86%', height: 'auto' }}
            />
          </div>
        </div>
      </div>
    )
  };

  return (
    <div className={'div-loading-container'}>
      {_renderContent()}
    </div>
  )
}
